<template>
  <div class="space-y-6">
    <div class="flex-between">
      <h1 class="page-title">Dashboard</h1>
      <!-- <SwaggerUpload @uploaded="refreshStats" /> -->
    </div>

    <!-- Estatísticas -->
    <div class="stats-grid">
      <div class="stats-card">
        <div class="stats-number">{{ stats.totalApis }}</div>
        <div class="stats-label">Total de APIs</div>
      </div>
      <div class="stats-card">
        <div class="stats-number" style="color: #10b981;">{{ stats.activeApis }}</div>
        <div class="stats-label">APIs Ativas</div>
      </div>
      <div class="stats-card">
        <div class="stats-number" style="color: #3b82f6;">{{ stats.deprecatedApis }}</div>
        <div class="stats-label">APIs Depreciadas</div>
      </div>
    </div>

    <!-- APIs Recentes -->
    <div class="card">
      <div class="card-header">
        <h2 class="subtitle">APIs Recentes</h2>
      </div>
      <div class="card-content">
        <div v-if="recentApis.length === 0" class="empty-state">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <h3>Nenhuma API encontrada</h3>
          <p>Faça upload da primeira API para começar</p>
        </div>
        <div v-else class="grid grid-3">
          <ApiCardNew
            v-for="api in recentApis" 
            :key="api.id" 
            :api="api" 
            @click="viewApi(api.id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import ApiCardNew from '@/components/api/ApiCardNew.vue'
// import SwaggerUpload from '@/components/api/SwaggerUpload.vue'
import { getApiStats, getRecentApis, getLinkByApiId } from '@/services/api'

const router = useRouter()
const stats = ref({
  totalApis: 0,
  activeApis: 0,
  deprecatedApis: 0
})
const recentApis = ref([])

const loadStats = async () => {
  try {
    stats.value = await getApiStats()
  } catch (error) {
    console.error('Erro ao carregar estatísticas:', error)
  }
}

const loadRecentApis = async () => {
  try {
    recentApis.value = await getRecentApis()
  } catch (error) {
    console.error('Erro ao carregar APIs recentes:', error)
  }
}

const refreshStats = () => {
  loadStats()
  loadRecentApis()
}

const viewApi = (apiId) => {
  const link = getLinkByApiId(apiId)
  console.log(link)
  if (link) {
    router.push({ 
      name: 'ApiReferenceComponent', 
      params: { fileName: link } 
    })
  } else {
    // Fallback para a página de detalhes se não houver fileName
    router.push({ 
      name: 'ApiReferenceComponent', 
      params: { fileName: apiId } 
    })
  }
}

onMounted(() => {
  loadStats()
  loadRecentApis()
})
</script>